import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var WorldIcon = function WorldIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "WorldIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.51 7.269h2.194c.188-1.67.903-3.242 1.746-4.586a5.54 5.54 0 0 0-3.94 4.586M8 2.983C7.118 4.284 6.386 5.76 6.178 7.269h3.644C9.614 5.76 8.882 4.284 8 2.983M9.822 8.73c-.208 1.508-.94 2.985-1.822 4.286-.882-1.301-1.614-2.778-1.822-4.286zm-5.118 0H2.51a5.54 5.54 0 0 0 3.939 4.586c-.843-1.344-1.558-2.917-1.746-4.586m4.846 4.586c.843-1.344 1.558-2.917 1.746-4.586h2.193a5.54 5.54 0 0 1-3.939 4.586m3.94-6.048h-2.194c-.188-1.67-.903-3.242-1.746-4.586a5.54 5.54 0 0 1 3.94 4.586M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8",
      clipRule: "evenodd"
    })
  }));
};

export { WorldIcon };
